import {Component, Input} from '@angular/core';
import {UserInfo} from '@app/model/user-info.model';

@Component({
	selector: 'app-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {
	@Input() userInfo!: UserInfo | null;
}
